<template>
<div class="orderList">
    <npHeader :param="param" @toggleTab="toggleTab" :flag="flag" :title="title"></npHeader>
    <div class="data-total">
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">收款笔数</div>
                    <div class="box-data"><span class="data">{{item.ordersucccount}}</span>笔</div>
                </div>
            </div>
            <el-tooltip content="当前活动总收款笔数" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">收款总额</div>
                    <div class="box-data"><span class="data">{{item.totalincome}}</span>元</div>
                </div>
            </div>

            <el-tooltip content="当前活动总收款金额" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">手续费</div>
                    <div class="box-data"><span class="data">{{item.totalpoundage}}</span>元</div>
                </div>
            </div>

            <el-tooltip content="包含微信商户收款手续费" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">返现金额</div>
                    <div class="box-data"><span class="data">{{item.brokerage}}</span>元</div>
                </div>
            </div>
            <el-tooltip content="当前活动一二级返现总金额" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <!-- <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">已提金额</div>
                    <div class="box-data"><span class="data">{{item.disusersettlemoney}}</span>元</div>
                </div>
            </div>
            <el-tooltip content="分销用户已经提现的金额" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div> -->
        <div class="outbox box-shadow bgc">
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">实收金额</div>
                    <div class="box-data"><span class="data">{{item.factincome}}</span>元</div>
                </div>
            </div>
            <el-tooltip content="当前活动扣除手续费和返现之后的实收金额" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
    </div>
    <div class="filters padding-20 bgc">
        <div class="add">
            <el-button v-if="permission.btnList.indexOf('A09')==-1" type="success" @click="handleExport">导出excel</el-button>
        </div>
        <div class="search">
            <el-select v-model="param.paytype" placeholder="请输入关键词选择" >
                <el-option v-for="item in paystatusList" :key="item.code" :label="item.name" :value="item.code">{{item.name}}</el-option>
            </el-select>
            <el-input v-model="param.payorderno" placeholder="支付订单号" class="condition" clearable></el-input>
            <el-input v-model="param.username" placeholder="用户昵称" class="condition" clearable></el-input>
            <el-input v-model="param.parentnameone" placeholder="上级昵称" class="condition" clearable></el-input>
            <!--<el-input v-model="param.parentnametwo" placeholder="间接上级昵称" class="condition" clearable></el-input>-->
            <el-input v-model="param.chname" placeholder="请输入渠道名称" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list padding-20 bgc">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="orderno" label="订单号" class-name="center" max-width="180"></el-table-column>
            <el-table-column prop="customername" label="用户昵称" class-name="center" min-width="120" max-width="180">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img :src="scope.row.customericonurl" alt="" v-if="scope.row.customericonurl">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="finalpaymoney" label="支付金额" class-name="center"  min-width="80">
                <template slot-scope="scope">￥{{scope.row.finalpaymoney}}</template>
            </el-table-column>
            <el-table-column prop="paystatus" label="支付状态" class-name="center"  min-width="80">
                <template slot-scope="scope">
                    <span :class="paystatus(scope.row.paystatus)">{{scope.row.paystatustext}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="parentname01" label="直接上级" class-name="center" min-width="80">
                <template slot-scope="scope">
                <!-- <div class="imageText">
                    <img :src="scope.row.parenturl01" alt="" v-if="scope.row.parenturl01">
                </div> -->
                {{scope.row.parentname01}}
                </template>
            </el-table-column>
            <el-table-column prop="parentimoney01" label="直接返现" class-name="center"  min-width="80">
                <template slot-scope="scope">￥{{scope.row.parentimoney01}}</template>
            </el-table-column>
            <el-table-column prop="parentname02" label="间接上级" class-name="center" min-width="80">
                <template slot-scope="scope">
                <!-- <div class="imageText">
                    <img :src="scope.row.parenturl02" alt="" v-if="scope.row.parenturl02">
                    <span>{{scope.row.parentname02}}</span>
                </div> -->
                {{scope.row.parentname02}}
                </template>
            </el-table-column>
            <el-table-column prop="parentimoney02" label="间接返现" class-name="center"  min-width="80">
                <template slot-scope="scope">￥{{scope.row.parentimoney02}}</template>
            </el-table-column>
            <el-table-column prop="datetime" label="订单时间" class-name="center" width="120"></el-table-column>
            <el-table-column prop="checkstatusname" label="核销状态" class-name="center" min-width="80"></el-table-column>
            <el-table-column prop="chname" label="渠道名称" class-name="center" min-width="80"></el-table-column>
            <el-table-column label="操作" width="160" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span v-if="scope.row.paystatus==10 && scope.row.resulttype == 5 &&  scope.row.isship == 0" class="separator-btn">
                            <el-button @click="handleSendAddr(scope.row)" type="text" size="small">发货</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click="handleView(scope.row)" type="text" size="small">详情</el-button>
                        </span>
                        <span  v-if="scope.row.paystatus==10" class="separator-btn">
                            <el-button @click="handleQueryTotal(scope.row)" type="text" size="small">查看佣金</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="page">
            <el-pagination background
                           @current-change="_getList"
                           :current-page.sync="page.page"
                           :page-size="page.pageSize"
                           :pager-count="11"
                           layout="prev, pager, next"
                           :total="total">
            </el-pagination>
        </div>
    </div>
    <PopCommission :popData="popData" ref="popCommission"></PopCommission>
    <PopSendAddr :popData="popData" ref="popSendAddr" @getList="_getList"></PopSendAddr>
    <PopOrderView ref="popOrderView"></PopOrderView>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getOrderInfoList, getOrderTopInfoCount, exportOrderList, getOrderBrokerageInfo, getOrderShipInfo} from 'api/nationalDistribution'
import {nationalDistribution} from 'api/enumCode'
import {dateFormat} from 'common/js/tools'
import PopCommission from 'views/tools/nationalDistribution/order/components/popCommission.vue'
import PopSendAddr from 'views/tools/nationalDistribution/order/components/popSendAddr.vue'
import PopOrderView from 'views/tools/nationalDistribution/order/components/popOrderView.vue'
import NpHeader from 'views/tools/nationalDistribution/components/npHeader.vue'
export default {
    name: 'orderList',
    data() {
        return {
            title: '订单管理',
            paystatusList: nationalDistribution.paystatus,
            tableData: [],
            total: 0,
            power: {},
            item: {
                brokerage: 0,
                factincome: 0,
                ordersucccount: 0,
                totalincome: 0,
                disusersettlemoney: 0,
                totalpoundage: 0
            },
            popData: {
                orderView: {},
                dataList: []
            },
            page: {
                page: 1,
                pageSize: 10
            }
        }
    },
    props: ['param', 'flag'],
    mounted() {
        this.power = this.permission.btnObj.A09 ? this.permission.btnObj.A09 : []
    },
    methods: {
        handleView(obj) {
            this.$refs.popOrderView.open(this.param.eventinnerid, obj.orderno)
        },
        toggleTab() {
            this.param.paytype = ''
            this.param.username = ''
            this.param.parentnameone = ''
            this.param.parentnametwo = ''
            this.setParams(this._.cloneDeep(this.param))
            this._getOrderTopInfoCount()
        },
        handleQueryTotal(obj) {
            this.setLoading(true)
            getOrderBrokerageInfo({
                data: {orderno: obj.orderno},
                success: data => {
                    this.popData.orderView = obj
                    this.popData.dataList = data.data.content
                    this.setLoading(false)
                    this.$refs.popCommission.open()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleSendAddr(obj) {
            this.popData.orderView = obj
            this.setLoading(true)
            getOrderShipInfo({
                data: {
                    orderno: obj.orderno,
                    eventinnerid: this.param.eventinnerid
                },
                success: data => {
                    this.popData = data.data
                    this.setLoading(false)
                    this.$refs.popSendAddr.open(this.param.eventinnerid, this.popData)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleExport() {
            this.setLoading(true)
            exportOrderList({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '订单列表' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        handleAdd() {
            this.$router.push({name: 'NDWithdrawalEdit'})
        },
        _getOrderTopInfoCount() {
            this.setLoading(true)
            getOrderTopInfoCount({
                data: Object.assign({}, {eventinnerid: this.param.eventinnerid}, this.page),
                success: data => {
                    this.item = data.data
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            getOrderInfoList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.loading = false
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.loading = false
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {
        status: function (value) {
            return value
        }
    },
    watch: {},
    computed: {
        paystatus () {
            return function(value) {
                for (let i = 0; i < nationalDistribution.paystatus.length; i++) {
                    if (value === nationalDistribution.paystatus[i].code) {
                        return nationalDistribution.paystatus[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters([
            'user',
            'permission',
            'params'
        ])
    },
    components: {
        PopCommission, PopSendAddr, NpHeader, PopOrderView
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.orderList {
    .data-total{
        margin-top: 24px;
        @include flexBox(space-between);
        .outbox{
            padding: 30px;
            height: 100px;
            box-sizing: border-box;
            position: relative;
            flex-grow: 1;
            flex-basis: 200px;
            .box{}
            .el-tooltip{
                position: absolute;
                width: 14px;
                height: 14px;
                top: 10px;
                right: 10px;
            }
        }
        .outbox+.outbox{
            margin-left: 40px;
        }
    }
    .filters{
        margin-top: 24px;
        margin-bottom: 0;
        padding: 20px 20px 10px 20px;
        input{
        width: 130px;
        }
        .el-select{
            input{
                width: 100px;
            }
        }
    }
    .imageText{
        img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
}
</style>
